import {connect} from "react-redux";
import LogoutPage from "./LogoutPage";
import * as authActions from "../actions/AuthActions";

function mapStateToProps(state) {
  return {

  }
}

export default connect(mapStateToProps, {...authActions})(LogoutPage);